import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    flex-direction: column; 

`;


export const Input = styled.input`

width:100%;
background-color: ${theme.colors.light};
color: ${theme.colors.dark};

font-size: max(12px, 1.4vw);
border:none;
border-radius: 0.25rem;
padding: 1vh 2vw;

margin-bottom:2vh;

`;




export const Button = styled.button`
  margin: auto;

  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
`;